// src/GoogleAnalyticsTracker.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GA_MEASUREMENT_ID = "G-3HSVES9LXH";

export default function GoogleAnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    if (!window.gtag) return;

    const pagePath = `${location.pathname}${location.search}`;
    const pageLocation = `${window.location.origin}${window.location.pathname}#${pagePath}`;

    window.gtag("event", "page_view", {
      page_title: document.title,
      page_location: pageLocation,
      page_path: pagePath,
      send_to: GA_MEASUREMENT_ID,
    });
  }, [location]);

  return null;
}
